import script from "./SubscriptionPaymentAmount.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SubscriptionPaymentAmount.vue?vue&type=script&lang=js"
export * from "./SubscriptionPaymentAmount.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SubscriptionPaymentAmount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/subscription-payment-card/SubscriptionPaymentAmount.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e0a532c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e0a532c', __exports__)) {
    api.reload('3e0a532c', __exports__)
  }
  
}


export default __exports__